import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  condition: string;
  quote: string;
  result: string;
}
export function TestimonialCard({
  name,
  condition,
  quote,
  result
}: TestimonialCardProps) {
  return <div className="bg-slate-800/60 backdrop-blur-sm p-6 rounded-xl shadow-xl border border-fuchsia-500/20 hover:shadow-2xl hover:shadow-cyan-500/20 hover:border-cyan-500/30 transition-all duration-300 relative overflow-hidden group" data-id="element-254">
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-fuchsia-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-255"></div>
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-cyan-500/10 to-transparent rounded-full blur-2xl" data-id="element-256"></div>
      <div className="relative" data-id="element-257">
        <div className="flex gap-1 mb-4" data-id="element-258">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-cyan-400 text-cyan-400" data-id="element-259" />)}
        </div>
        <p className="text-cyan-100 mb-5 italic font-medium leading-relaxed line-clamp-4" data-id="element-260">
          "{quote}"
        </p>
        <div className="border-t border-fuchsia-500/20 pt-4" data-id="element-261">
          <p className="font-bold text-white mb-1" data-id="element-262">{name}</p>
          <p className="text-sm text-fuchsia-300 font-semibold mb-3" data-id="element-263">
            {condition}
          </p>
          <div className="inline-block bg-gradient-to-r from-cyan-500 to-fuchsia-500 px-3 py-1.5 rounded-full" data-id="element-264">
            <p className="text-xs font-bold text-white" data-id="element-265">{result}</p>
          </div>
        </div>
      </div>
    </div>;
}